import { GET_ENTERPRISES_START } from '../../types';

export const get_enterprises = (payload) => ({
  type: GET_ENTERPRISES_START,
  payload,
});
